import { EMAIL_ITEM_ID_KEY } from '../../../../../Email'

function getActiveItemAbsoluteIndex({ indexInPage, page, pageSize }) {
  return indexInPage === -1 ? -1 : (page - 1) * pageSize + indexInPage
}

function getActiveItemIndexInPage(items, activeItem) {
  return items.findIndex(item => item[EMAIL_ITEM_ID_KEY] === activeItem)
}

function getIsEdgeNavigationPending(edgeNavigationTarget, items) {
  return Boolean(
    edgeNavigationTarget && edgeNavigationTarget.itemsBeforeNavigation === items
  )
}

function getIsNavigationEnabled({ currentIndex, totalCount }) {
  return currentIndex > -1 && totalCount > 0
}

export function getPreviewNavigationState({
  activeItem,
  edgeNavigationTarget,
  items,
  itemsList,
  pagination,
}) {
  const indexInPage = getActiveItemIndexInPage(itemsList, activeItem)

  const page = pagination?.page ?? 1
  const pageSize = pagination?.pageSize ?? 0

  const isEdgeNavigationPending = getIsEdgeNavigationPending(
    edgeNavigationTarget,
    items
  )

  return {
    currentIndex: isEdgeNavigationPending
      ? edgeNavigationTarget.targetIndex
      : getActiveItemAbsoluteIndex({ indexInPage, page, pageSize }),
    indexInPage,
    isEdgeNavigationPending,
    itemsCount: itemsList.length,
    page,
    totalCount: pagination?.count ?? 0,
  }
}

export function getCanGoNextInPage({
  indexInPage,
  isEdgeNavigationPending,
  itemsCount,
}) {
  return (
    !isEdgeNavigationPending &&
    indexInPage !== -1 &&
    indexInPage < itemsCount - 1
  )
}

export function getCanGoNextToNextPage({
  currentIndex,
  indexInPage,
  isEdgeNavigationPending,
  totalCount,
}) {
  return (
    !isEdgeNavigationPending &&
    indexInPage !== -1 &&
    currentIndex < totalCount - 1
  )
}

export function getCanGoPrevInPage({ indexInPage, isEdgeNavigationPending }) {
  return !isEdgeNavigationPending && indexInPage > 0
}

export function getCanGoPrevToPreviousPage({
  indexInPage,
  isEdgeNavigationPending,
  page,
}) {
  return !isEdgeNavigationPending && indexInPage === 0 && page > 1
}

export function getEdgeItemId(items, direction) {
  const edgeItem = direction > 0 ? items[0] : items[items.length - 1]

  return edgeItem[EMAIL_ITEM_ID_KEY]
}

export function getHasNext(navigationState) {
  return (
    getCanGoNextInPage(navigationState) ||
    getCanGoNextToNextPage(navigationState)
  )
}

export function getHasPrevious(navigationState) {
  return (
    getCanGoPrevInPage(navigationState) ||
    getCanGoPrevToPreviousPage(navigationState)
  )
}

// The shared header counter is 1-based and hidden while the row is unknown
export function getOneBasedCurrentIndex(navigationState) {
  return getIsNavigationEnabled(navigationState)
    ? navigationState.currentIndex + 1
    : null
}

export function getItemIdAtIndex(items, index) {
  return items[index][EMAIL_ITEM_ID_KEY]
}
